export default __webpack_public_path__ + "static/media/logo-mercadopago-small.6de1d3bd.png";